import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../services/api";
import InsightCard from "../components/InsightCard";

export default function Insights() {
  const [insights, setInsights] = useState([]);
  const [filters, setFilters] = useState(null);
  const [sel, setSel] = useState({ region: "", dealer: "", sku: "", plant: "", severity: "" });
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => { api.filters().then(setFilters); }, []);
  useEffect(() => { setOpenId(params.get("open")); }, [params]);

  const load = (s) => {
    setLoading(true);
    const clean = Object.fromEntries(Object.entries(s).filter(([, v]) => v));
    api.insights(clean).then((d) => { setInsights(d.insights); setLoading(false); });
  };
  useEffect(() => { load(sel); /* eslint-disable-next-line */ }, [sel]);

  const set = (k, v) => setSel((p) => ({ ...p, [k]: v }));
  const reset = () => setSel({ region: "", dealer: "", sku: "", plant: "", severity: "" });
  const active = Object.values(sel).some(Boolean);

  return (
    <div className="insights-page">
      {filters && (
        <div className="filter-bar">
          <FilterSelect label="Region" value={sel.region} onChange={(v) => set("region", v)} options={filters.regions.map((r) => ({ value: r, label: r }))} />
          <FilterSelect label="Severity" value={sel.severity} onChange={(v) => set("severity", v)} options={filters.severities.map((r) => ({ value: r, label: r }))} />
          <FilterSelect label="Dealer" value={sel.dealer} onChange={(v) => set("dealer", v)} options={filters.dealers.map((d) => ({ value: d.id, label: d.name }))} />
          <FilterSelect label="SKU" value={sel.sku} onChange={(v) => set("sku", v)} options={filters.skus.map((s) => ({ value: s.id, label: s.name }))} />
          <FilterSelect label="Plant" value={sel.plant} onChange={(v) => set("plant", v)} options={filters.plants.map((p) => ({ value: p.id, label: p.name }))} />
          {active && <button className="btn-ghost sm" onClick={reset}>Clear filters</button>}
          <span className="filter-count">{insights.length} insight{insights.length !== 1 ? "s" : ""}</span>
        </div>
      )}

      {loading ? (
        <div className="loading-page">Correlating signals…</div>
      ) : insights.length === 0 ? (
        <div className="empty-state">No correlated situations match these filters.</div>
      ) : (
        <div className="insight-list">
          {insights.map((i) => (
            <InsightCard key={i.id} insight={i} defaultOpen={openId === i.id}
              onOpenGraph={(id) => nav(`/graph?focus=${id}`)} />
          ))}
        </div>
      )}
    </div>
  );
}

function FilterSelect({ label, value, onChange, options }) {
  return (
    <label className="filter-select">
      <span>{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">All</option>
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
  );
}
